var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9167 44.7917L25 5.20834L2.08334 44.7917H47.9167ZM22.9167 38.5417V34.375H27.0833V38.5417H22.9167ZM22.9167 30.2083H27.0833V21.875H22.9167V30.2083Z",
    fill: "#FFDF03"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.2693239e4995d4d7c73a3c053af73a3f.svg";
export { ForwardRef as ReactComponent };